export const convertAmount = amount => {
  amount = Number(amount)

  if (!amount) return 0

  return `${parseFloat((amount/1000000).toFixed(2))}M`
}